export const searchByLabelProps = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "label" as const,
  filterOption: (input: string, option?: { label?: unknown }) =>
    String(option?.label ?? "")
      .toLowerCase()
      .includes(input.toLowerCase()),
};
